<div class="Popup" id="DialogForm">

  <div class="popup-inner-space">
    <div class="betweenheader  color_black">Select Meter Type</div>
    <div class="text-right flow-right">
      <img src="assets/images/close_icon.svg" id="close-icon" alt="..."
        class="img-fluid close-space23 closeicon2 cursor-pointer" (click)="Close()">
    </div>
  </div>
  <div class="popup-inner-space">
    <div mat-dialog-actions class="Cancelactionsection">
      <button class="btncommon" id="btn-yes" (click)="Metertype('Analog')">Analog</button>
      <button class="btncommon  margin-left-10" id="btn-yes" (click)="Metertype('Digital')">Digital</button>
      <button class="btncommon  margin-left-10" id="btn-yes" (click)="Metertype('Virtual')">Virtual</button>
    </div>
  </div>
</div>